export default "__VITE_ASSET__CvAlV$7___"